export { type TabItem, default } from './TabsWrapper'
